import React, { useState } from 'react';
import { getProductSummaryLabel } from '../helpers/buildPdfPayloadFromText';

function MultiProductChoice({ payload, onConfirm, onBack }) {
  const [mode, setMode] = useState(payload.pdfOutputMode || 'combined');
  const products = payload.products || [];

  return (
    <div className="space-y-6">
      <div>
        <h2 className="text-xl font-bold text-gray-900 mb-2">Multiple products detected</h2>
        <p className="text-gray-600 text-sm">
          We found {products.length} products in your pasted text. Choose how you want the PDFs generated.
        </p>
      </div>

      <ul className="border border-gray-200 rounded-lg divide-y divide-gray-100">
        {products.map((product, index) => (
          <li key={index} className="px-4 py-3 text-sm text-gray-800">
            <span className="font-semibold text-indigo-700">{getProductSummaryLabel(product, index, products)}</span>
          </li>
        ))}
      </ul>

      <div className="space-y-3">
        <label className={`flex items-start gap-3 border rounded-lg p-4 cursor-pointer ${mode === 'combined' ? 'border-indigo-500 bg-indigo-50' : 'border-gray-200'}`}>
          <input
            type="radio"
            name="pdfOutputMode"
            value="combined"
            checked={mode === 'combined'}
            onChange={() => setMode('combined')}
            className="mt-1"
          />
          <div>
            <span className="font-semibold text-gray-900">One PDF — all products</span>
            <p className="text-xs text-gray-600 mt-1">
              Single file with {products.length} pages (one page per product). Best for sending one combined quote.
            </p>
          </div>
        </label>

        <label className={`flex items-start gap-3 border rounded-lg p-4 cursor-pointer ${mode === 'separate' ? 'border-indigo-500 bg-indigo-50' : 'border-gray-200'}`}>
          <input
            type="radio"
            name="pdfOutputMode"
            value="separate"
            checked={mode === 'separate'}
            onChange={() => setMode('separate')}
            className="mt-1"
          />
          <div>
            <span className="font-semibold text-gray-900">Separate PDFs — one per product</span>
            <p className="text-xs text-gray-600 mt-1">
              Downloads {products.length} files (e.g. Bags.pdf, Labels.pdf). Preview one product at a time while editing.
            </p>
          </div>
        </label>
      </div>

      <div className="flex flex-wrap gap-3">
        <button type="button" onClick={onBack} className="px-4 py-2 border border-gray-300 rounded-lg text-sm hover:bg-gray-50">
          Back
        </button>
        <button
          type="button"
          onClick={() => onConfirm({ ...payload, pdfOutputMode: mode })}
          className="px-6 py-2 bg-indigo-600 text-white rounded-lg text-sm font-medium hover:bg-indigo-700"
        >
          Continue to preview
        </button>
      </div>
    </div>
  );
}

export default MultiProductChoice;
